import logo from "../../assets/images/sideLogo.png";
import "./resultTitle.css";

export const ResultTitle = ({ resultData, date }) => {
	return (
		<section className="mt-5 p-4">
			<header className="d-flex justify-content-center">
				<img src={logo} alt={"logo"} className="personnel-image" />
			</header>
			<div className="divider" />

			<h2 className="result_desc">{`Department of ${resultData?.department} Score Sheet ${resultData?.semester} Semester`}</h2>
			<div className="mt-5 row">
				<div className="header_container">
					<div>
						<div className="student_details_grid">
							<div>Course code:</div>
							<div>{resultData?.courseCode}</div>
						</div>
						<div className="student_details_grid">
							<div>Course title:</div>
							<div>{resultData?.courseTitle}</div>
						</div>
					</div>
					<div>
						<div className="student_details_grid">
							<div>Session:</div>
							<div>{resultData?.session}</div>
						</div>
						<div className="student_details_grid">
							<div>Level:</div>
							<div>{resultData?.level ?? ""}</div>
						</div>
					</div>
					<div>
						<div className="student_details_grid">
							<div>Total Credit:</div>
							<div>{resultData?.courseUnit} cr</div>
						</div>
						<div className="student_details_grid">
							<div>Date:</div>
							<div>{date}</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
